import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';
import AuthService from './../auth_components/js/AuthService';
import { Drawer, Divider, List, ListItem, ListItemIcon, ListItemText, Collapse, Typography } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
const drawerWidth = 200;

const styles = theme => ({
    root: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        backgroundColor: '#2196F3'
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: '#f5f5f5',
        borderRight: '1px solid #e0e0e0',
    },
    toolbar: theme.mixins.toolbar,
    navIconHide: {
        display: 'block',
        [theme.breakpoints.up('xl')]: {
            display: 'none'
        }
    },
    listSmall: {
        paddingLeft: '40px !important',
        '& .MuiListItemText-primary': {
            fontSize: '0.85rem'
        }
    },
    groupTitle: {
        paddingLeft: '16px',
        paddingTop: '8px',
        paddingBottom: '4px',
        fontSize: '0.65rem',
        fontWeight: 700,
        color: '#999',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        transition: 'opacity 0.3s ease',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginRight: '4px',
        '&:hover': {
            color: '#666'
        }
    },
    menuItem: {
        paddingTop: '6px',
        paddingBottom: '6px',
        '& .MuiListItemText-primary': {
            fontSize: '0.9rem'
        }
    },
    listContainer: {
        paddingTop: '6px',
        paddingBottom: '6px'
    },
    divider: {
        margin: '6px 0'
    },
    panelHeaderWrap: {
        padding: '12px 16px 10px 16px'
    },
    panelHeaderText: {
        fontSize: '0.72rem',
        fontWeight: 700,
        letterSpacing: '0.7px',
        textTransform: 'uppercase',
        color: '#424242'
    },
    panelHeaderSubText: {
        fontSize: '0.68rem',
        color: '#757575',
        marginTop: '2px'
    }
});

const superAdminMenuGroups = [
    {
        groupName: "Main",
        items: [
            {
                title: "Dashboard",
                link: "/",
                submenu: []
            }
        ]
    },
    {
        groupName: "Quick Access",
        items: [
            {
                title: "Notifications",
                link: "/notices",
                submenu: [
                    {
                        title: "View All",
                        link: "/view"
                    }
                ]
            },
            {
                title: "Tenders",
                link: "/tender",
                submenu: []
            },
            {
                title: "News",
                link: "/news",
                submenu: []
            },
            {
                title: "Events",
                link: "/events",
                submenu: []
            }
        ]
    },
    {
        groupName: "Academics",
        items: [
            {
                title: "Course Outcomes",
                link: "/courseoutcome/view",
                submenu: []
            },
            {
                title: "Activity",
                link: "/activity/view",
                submenu: []
            },
            {
                title: "Facility",
                link: "/facility/view",
                submenu: []
            }
        ]
    },
    {
        groupName: "Files",
        items: [
            {
                title: "File Group",
                link: "/filegroup/view",
                submenu: []
            },
            {
                title: "File Group Item",
                link: "/filegroupitem/view",
                submenu: []
            }
        ]
    },
    {
        groupName: "Compliance",
        items: [
            {
                title: "IQAC",
                link: "/iqac-new",
                submenu: []
            },
            {
                title: "ITEP",
                link: "/itep",
                submenu: []
            },
            {
                title: "Library",
                link: "/library",
                submenu: []
            },
            {
                title: "Unit & Cells",
                link: "/unitcell",
                submenu: []
            },
            {
                title: "Programmes Offered",
                link: "/programmes",
                submenu: []
            }
        ]
    },
    {
        groupName: "Management",
        items: [
            {
                title: "Departments",
                link: "/master/department",
                submenu: []
            },
            {
                title: "Employees",
                link: "/employee",
                submenu: []
            },
            {
                title: "Logs",
                link: "/logs",
                submenu: []
            },
            {
                title: "Photo Gallery",
                link: "/gallery-photo",
                submenu: []
            },
            {
                title: "Awards & Achievements",
                link: "/gallery-award",
                submenu: []
            },
            {
                title: "Homepage Banner",
                link: "/home-banner",
                submenu: []
            }
        ]
    }
];


const departmentMenuGroups = [
    {
        groupName: "Department",
        items: [
            {
                title: "Glance",
                link: "/department/glance",
                submenu: []
            },
            {
                title: "Banner",
                link: "/department/banner",
                submenu: []
            },
            {
                title: "Courses",
                link: "/department/courses",
                submenu: []
            },
            {
                title: "Syllabus",
                link: "/department/syllabus",
                submenu: []
            },
            {
                title: "Journal",
                link: "/department/journal",
                submenu: []
            },
            {
                title: "Achievements",
                link: "/department/achievements",
                submenu: []
            },
            {
                title: "Faculty",
                link: "/department/faculty",
                submenu: []
            },
            {
                title: "COs & POs",
                link: "/department/co-po",
                submenu: []
            },
            {
                title: "Profile",
                link: "/department/profile",
                submenu: []
            },
            {
                title: "Gallery",
                link: "/department/gallery",
                submenu: []
            },
            {
                title: "Contact",
                link: "/department/contact",
                submenu: []
            }
        ]
    }
];

const facultyMenuGroups = [
    {
        groupName: "Faculty",
        items: [
            {
                title: "Home",
                link: "/faculty/home",
                submenu: []
            },
            {
                title: "About Me",
                link: "/faculty/about-me",
                submenu: []
            },
            {
                title: "Seminars",
                link: "/faculty/seminars",
                submenu: []
            },
            {
                title: "Research",
                link: "/faculty/research",
                submenu: []
            },
            {
                title: "Publications",
                link: "/faculty/publications",
                submenu: []
            },
            {
                title: "Workshops",
                link: "/faculty/workshops",
                submenu: []
            },
            {
                title: "PHD & M.Phil",
                link: "/faculty/phd",
                submenu: []
            },
            {
                title: "Involvement",
                link: "/faculty/involvement",
                submenu: []
            },
            {
                title: "Achievements",
                link: "/faculty/achievements",
                submenu: []
            },
            {
                title: "Awards",
                link: "/faculty/awards",
                submenu: []
            },
            {
                title: "Others",
                link: "/faculty/others",
                submenu: []
            },
            {
                title: "Guideship",
                link: "/faculty/guideship",
                submenu: []
            }
        ]
    }
];


class DrawerMain extends React.Component {
    constructor(props) {
        super(props);
        const userRole = this.getCurrentUserRole();
        const menuGroups = this.getResolvedMenuGroupsByRole(userRole);
        const isSimpleMenu = userRole !== 'SUPERADMIN';
        this.state = {
            anchorEl: null,
            mobileMoreAnchorEl: null,
            userRole,
            groupOpen: new Array(menuGroups.length).fill(isSimpleMenu),
            submenuOpen: {}
        };
    }

    getCurrentUser = () => {
        try {
            const auth = new AuthService();
            return auth.getUser();
        } catch (e) {
            return null;
        }
    }

    getCurrentUserRole = () => {
        let role = 'SUPERADMIN';
        const user = this.getCurrentUser();
        if (user && user.user && user.user.role) {
            role = String(user.user.role).toUpperCase();
        }
        return role;
    }

    getMenuGroupsByRole = (role) => {
        if (role === 'SUPERADMIN') {
            return superAdminMenuGroups;
        }

        if (role === 'FACULTY') {
            return facultyMenuGroups;
        }

        return departmentMenuGroups;
    }

    getDepartmentCode = () => {
        const role = this.getCurrentUserRole();

        if (role === 'SUPERADMIN' || role === 'FACULTY') {
            return '';
        }

        return role;
    }

    getFacultyEmployeeId = () => {
        const user = this.getCurrentUser();

        if (!user || !user.user) {
            return '';
        }

        const possibleEmployeeIds = [
            user.user.employee_id,
            user.user.employeeId,
            user.user.emp_id,
            user.user.userid,
            user.user.id
        ];

        const employeeId = possibleEmployeeIds.find((value) => {
            return value !== undefined && value !== null && String(value).trim() !== '';
        });

        if (!employeeId) {
            return '';
        }

        return String(employeeId);
    }

    buildDepartmentLink = (link, departmentCode) => {
        if (!departmentCode || link.indexOf('/department/') !== 0) {
            return link;
        }

        const linkSuffix = link.replace('/department/', '');
        return `/department/${departmentCode}/${linkSuffix}`;
    }

    buildFacultyLink = (link, employeeId) => {
        if (!employeeId || link.indexOf('/faculty/') !== 0) {
            return link;
        }

        const linkSuffix = link.replace('/faculty/', '');
        return `/faculty/${employeeId}/${linkSuffix}`;
    }

    getResolvedMenuGroupsByRole = (role) => {
        const menuGroups = this.getMenuGroupsByRole(role);

        if (role === 'SUPERADMIN') {
            return menuGroups;
        }

        if (role === 'FACULTY') {
            const employeeId = this.getFacultyEmployeeId();

            return menuGroups.map((group) => ({
                ...group,
                items: group.items.map((item) => ({
                    ...item,
                    link: this.buildFacultyLink(item.link, employeeId),
                    submenu: item.submenu.map((subitem) => ({
                        ...subitem,
                        link: this.buildFacultyLink(subitem.link, employeeId)
                    }))
                }))
            }));
        }

        const departmentCode = this.getDepartmentCode();

        return menuGroups.map((group) => ({
            ...group,
            items: group.items.map((item) => ({
                ...item,
                link: this.buildDepartmentLink(item.link, departmentCode),
                submenu: item.submenu.map((subitem) => ({
                    ...subitem,
                    link: this.buildDepartmentLink(subitem.link, departmentCode)
                }))
            }))
        }));
    }

    getPanelHeaderByRole = (role) => {
        if (role === 'SUPERADMIN') {
            return {
                title: 'Superadmin Panel',
                subtitle: 'Global controls'
            };
        }

        if (role === 'FACULTY') {
            return {
                title: 'Faculty Panel',
                subtitle: 'Personal profile controls'
            };
        }

        return {
            title: 'Department Panel',
            subtitle: 'Department controls'
        };
    }

    componentDidMount() {
        const role = this.getCurrentUserRole();
        const roleChanged = role !== this.state.userRole;
        if (roleChanged) {
            const menuGroups = this.getResolvedMenuGroupsByRole(role);
            const isSimpleMenu = role !== 'SUPERADMIN';
            this.setState({
                userRole: role,
                groupOpen: new Array(menuGroups.length).fill(isSimpleMenu),
                submenuOpen: {}
            });
        }
    }

    handleGroupToggle = (groupIndex) => {
        let groupOpen = this.state.groupOpen;
        groupOpen[groupIndex] = !groupOpen[groupIndex];
        this.setState({ groupOpen });
    }

    handleSubmenuToggle = (groupIndex, itemIndex) => {
        const key = `${groupIndex}-${itemIndex}`;
        let submenuOpen = { ...this.state.submenuOpen };
        submenuOpen[key] = !submenuOpen[key];
        this.setState({ submenuOpen });
    }

    handleProfileMenuOpen = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
        this.handleMobileMenuClose();
    };

    handleMobileMenuOpen = event => {
        this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    handleMobileMenuClose = () => {
        this.setState({ mobileMoreAnchorEl: null });
    };

    render() {
        const { anchorEl, mobileMoreAnchorEl, groupOpen, submenuOpen, userRole } = this.state;
        const { classes } = this.props;
        const menuGroups = this.getResolvedMenuGroupsByRole(userRole);
        const panelHeader = this.getPanelHeaderByRole(userRole);
        const isSimpleMenu = userRole !== 'SUPERADMIN';

        let menu = [];

        if (isSimpleMenu) {
            const flatItems = menuGroups.reduce((acc, group) => acc.concat(group.items), []);
            menu = (
                <List disablePadding className={classes.listContainer}>
                    {flatItems.map((item, itemIndex) => {
                        const submenuKey = `simple-${itemIndex}`;
                        const isSubmenuOpen = submenuOpen[submenuKey] || false;

                        let expandIcon = null;
                        let submenuContent = null;

                        if (item.submenu.length > 0) {
                            expandIcon = isSubmenuOpen ? <ExpandLess /> : <ExpandMore />;
                            submenuContent = (
                                <Collapse in={isSubmenuOpen} timeout="auto" unmountOnExit>
                                    <List>
                                        {item.submenu.map((subitem, subindex) =>
                                            <Link to={subitem.link} key={subindex}>
                                                <ListItem button className={classes.listSmall}>
                                                    <ListItemText>
                                                        <Typography variant="body1">{subitem.title}</Typography>
                                                    </ListItemText>
                                                </ListItem>
                                            </Link>
                                        )}
                                    </List>
                                </Collapse>
                            );
                        }

                        return (
                            <div key={itemIndex}>
                                <Link to={item.link}>
                                    <ListItem
                                        button
                                        className={classes.menuItem}
                                        onClick={() => this.handleSubmenuToggle('simple', itemIndex)}
                                    >
                                        <ListItemText>
                                            <Typography variant="body2">{item.title}</Typography>
                                        </ListItemText>
                                        {expandIcon}
                                    </ListItem>
                                </Link>
                                {submenuContent}
                            </div>
                        );
                    })}
                </List>
            );
        } else {
            menu = menuGroups.map((group, groupIndex) => {
            const isGroupOpen = groupOpen[groupIndex];

            // Render group items
            const groupItems = group.items.map((item, itemIndex) => {
                const submenuKey = `${groupIndex}-${itemIndex}`;
                const isSubmenuOpen = submenuOpen[submenuKey] || false;

                let expandIcon = null;
                let submenuContent = null;

                if (item.submenu.length > 0) {
                    expandIcon = isSubmenuOpen ? <ExpandLess /> : <ExpandMore />;
                    submenuContent = (
                        <Collapse in={isSubmenuOpen} timeout="auto" unmountOnExit>
                            <List>
                                {item.submenu.map((subitem, subindex) =>
                                    <Link to={subitem.link} key={subindex}>
                                        <ListItem button className={classes.listSmall}>
                                            <ListItemText>
                                                <Typography variant="body1">{subitem.title}</Typography>
                                            </ListItemText>
                                        </ListItem>
                                    </Link>
                                )}
                            </List>
                        </Collapse>
                    );
                }

                return (
                    <div key={itemIndex}>
                        <Link to={item.link}>
                            <ListItem 
                                button 
                                className={classes.menuItem}
                                onClick={() => this.handleSubmenuToggle(groupIndex, itemIndex)}
                            >
                                <ListItemText>
                                    <Typography variant="body2">{item.title}</Typography>
                                </ListItemText>
                                {expandIcon}
                            </ListItem>
                        </Link>
                        {submenuContent}
                    </div>
                );
            });

            return (
                <div key={groupIndex}>
                    {/* Group Header - Collapsible */}
                    <div
                        className={classes.groupTitle}
                        onClick={() => this.handleGroupToggle(groupIndex)}
                    >
                        <span>{group.groupName}</span>
                        {isGroupOpen ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                    </div>

                    {/* Group Items Container */}
                    <Collapse in={isGroupOpen} timeout="auto" unmountOnExit>
                        <List disablePadding className={classes.listContainer}>
                            {groupItems}
                        </List>
                    </Collapse>

                    {/* Divider between groups */}
                    {groupIndex < menuGroups.length - 1 && <Divider className={classes.divider} />}
                </div>
            );
        });
        }

        return (
            <div>
                <Drawer
                    className={classes.drawer}
                    variant="permanent"
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    anchor="left"
                >
                    
                    <Divider />
                    <div className={classes.panelHeaderWrap}>
                        <Typography className={classes.panelHeaderText}>{panelHeader.title}</Typography>
                        <Typography className={classes.panelHeaderSubText}>{panelHeader.subtitle}</Typography>
                    </div>
                    <Divider />
                    {menu}
                </Drawer>
            </div>
        );
    }
}

DrawerMain.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DrawerMain);



// WEBPACK FOOTER //
// ./src/Components/DrawerMain.js